export const THINGS_TO_DO_SCHEMA_URL = 'https://heygirl.cutestperson.com/assets/public/schemas/ThingsToDo_v1.7.0.json' as const;
export const THINGS_TO_DO_COMPONENT_TYPE = 'ThingsToDo' as const;

export const categories = [
  { label: 'Attraction', value: 'attraction' },
  { label: 'Activity', value: 'activity' },
  { label: 'Bar', value: 'bar' },
  { label: 'Beach', value: 'beach' },
  { label: 'Breakfast', value: 'breakfast' },
  { label: 'Brewery', value: 'brewery' },
  { label: 'Brunch', value: 'brunch' },
  { label: 'Cocktail Bar', value: 'cocktailBar' },
  { label: 'Caffeine', value: 'caffeine' },
  { label: 'Dinner', value: 'dinner' },
  { label: 'Dive Bar', value: 'diveBar' },
  { label: 'Event', value: 'event' },
  { label: 'Food Truck', value: 'foodTruck' },
  { label: 'Landmark', value: 'landmark' },
  { label: 'Late Night', value: 'lateNight' },
  { label: 'Lunch', value: 'lunch' },
  { label: 'Museum', value: 'museum' },
  { label: 'Neighborhood', value: 'neighborhood' },
  { label: 'Park', value: 'park' },
  { label: 'Playground', value: 'playground' },
  { label: 'Hangout Spot', value: 'hangoutSpot' },
  { label: 'Hike', value: 'hike' },
  { label: 'Restaurant', value: 'restaurant' },
  { label: 'Shopping', value: 'shopping' },
  { label: 'Tour', value: 'tour' },
  { label: 'Walk', value: 'walk' },
  { label: 'Workout', value: 'workout' },
  { label: 'Custom', value: 'custom' },
] as const;
